Vue.component("meetingRoomLogin", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition name="assetOverviewAnimation">
            <div class="meetingRoomLogin__wrapper" v-if="componentReady">
                <h2 v-html="loginTitle"></h2>

                <div class="meetingRoomLogin__password" :class="{'input--passerror': wrongPassword === true}">
                    <input type="password" v-model="pass" placeholder="Password" @keyup="inputKeyupPassword">
                    <span>(Du har modtaget det i en email)</span>
                </div>

                <button class="meetingRoomLogin__loginbtn" @click="loginHandler">DELTAG</button>

                <button class="meetingRoomLogin__close" @click="close">
                    <img src="assets/img/ui/close-white.svg">
                </button>
            </div>
        </transition>
    `,
    data() {
        return {
            pass: '',
            password: '',
            route: '',
            title: '',
            sceneRoute: '',

            componentReady: false,
            wrongPassword: false,
            isValidPassword: false
        }
    },
    methods: { 
        inputKeyupPassword(event) {
            if(event.key == "Enter") {
                this.loginHandler();
            } else {
                this.wrongPassword = false;
            }
        },
        loginHandler() {
            this.isValidPassword = this.validatePassword(this.pass, this.password);

            if(this.isValidPassword) {
                this.goto();
            } else {
                this.wrongPassword = true;
            }
        },
        goto() {
            if(this.sceneRoute !== '') {
                console.log('GOTOSCENE', this.sceneRoute);

                var route = false;
                var sceneInfo = touchKit.PageManager.sceneInfo(this.sceneRoute);

                if (sceneInfo.route) {
                    route = '/' + sceneInfo.route;
                }

                if (route && this.$route.path !== route) {
                    this.$router.push(route);
                }
            } else if (this.route !== '') {
                this.$router.push(this.route)
            }
        },

        validatePassword (password, keymatch) {
            var md = forge.md.sha256.create();
            md.update(password);
            return md.digest().toHex() === keymatch;
        }
    },
    computed: {
        loginTitle(){ 
            return this.title == '' ? "Login" : this.title
        }
    },
    mounted() {
        // handle intro animation
        this.componentReady = true;
    },
})

touchKit.ComponentManager.register("meetingRoomLogin", {
    singleton: true
});